import { InjectionToken } from '@angular/core';

import { ErrorDialogData } from '@VineyardLib/data/error-dialog-data';

export interface ErrorDialogWrapperService {
  openErrorDialog: (errorDialogData: ErrorDialogData) => void;
  errorDialog?: any;
}

export const ERROR_DIALOG_SERVICE_TOKEN =
  new InjectionToken<ErrorDialogWrapperService>('ErrorDialogService');
